import { createGlobalStyle } from 'styled-components';
import styledNormalize from 'styled-normalize';
import swiperStyles from '../../lib/vendor/swiperStyles';
import amStyles from '../../lib/vendor/amStyles';
import theme from '../theme';
import { typographyVariables } from './typography';
import { colorVariables } from './colors';

const customStyles = `
  // Override pagination styles of carousel
  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-container-horizontal > .swiper-pagination-bullets {
      top: 0;
      bottom: auto;
      right: 0;
      left: auto;
      width: initial;
      ${theme.typographyRebrand.body.md}
      font-weight: var(--typography-font-weight-bold);
      color: ${theme.c.text.primary};
  }
`;

const modalStyles = `
  .ReactModal__Body--open {
    overflow-y: hidden;
  }
`;

const captchaStyles = `
  .grecaptcha-badge {
    position: absolute !important;
    bottom: 0px !important;
    right: 0px !important;
  }

  .recaptcha-challenge-position {
    position: fixed !important;
    top: 0 !important;
    transform: scale(0.8);
  }
`;

/**
 * Source: https://stackoverflow.com/questions/29981236/how-do-you-hover-in-reactjs-onmouseleave-not-registered-during-fast-hover-ove
 * How to setup your DOM elements to utilize CSS hover styles
 *
 * <div className="hover-container">
 *   <div className="default"></div>
 *   <div className="show-hover"></div>
 * </div>
 *
 * In IE, child elements do not inherit opacity from its parent. Fix is to apply position relative to the parent element.
 * Source: https://makandracards.com/makandra/21779-css-opacity-is-not-inherited-in-internet-explorer
 * */
const hoverStyles = `
  .hover-container:hover .show-hover {
     opacity: 1;
  }
 .hover-container:focus-within .show-hover {
  opacity: 1;
  }
  .hover-container:focus .show-hover {
    opacity: 0;
 }
  .show-hover {
     opacity: 0;
     position: relative;
     height: 100%;
  }
`;

/**
 * Source: https://codepen.io/stevenschobert/pen/dCsbr
 * */
const dotAnimationStyles = `
  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 100px;
    margin-left: -10px;
    margin-top: -50px;
    display: block;
    width: 72px;
  }

  .loader {
    position: relative;
    display: block;
    width: 100%;
    height: 10px;
    margin-top: 40px;
  }

  /* css circles*/
  .circle {
    display: inline-block;
    position: relative;
    -webkit-animation: dotloader 2.5s infinite;
    -moz-animation: dotloader 2.5s infinite;
    -ms-animation: dotloader 2.5s infinite;
    -o-animation: dotloader 2.5s infinite;
    animation: dotloader 2.5s infinite;
  }

  .circle + .circle {
    margin-left: -25px;
    -webkit-animation: dotloader 2.5s 0.2s infinite;
    -moz-animation: dotloader 2.5s 0.2s infinite;
    -ms-animation: dotloader 2.5s 0.2s infinite;
    -o-animation: dotloader 2.5s 0.2s infinite;
    animation: dotloader 2.5s 0.2s infinite;
  }

  .circle + .circle + .circle {
    margin-left: -25px;
    -webkit-animation: dotloader 2.5s 0.4s infinite;
    -moz-animation: dotloader 2.5s 0.4s infinite;
    -ms-animation: dotloader 2.5s 0.4s infinite;
    -o-animation: dotloader 2.5s 0.4s infinite;
    animation: dotloader 2.5s 0.4s infinite;
  }

  .circle + .circle + .circle + .circle {
    margin-left: -25px;
    -webkit-animation: dotloader 2.5s 0.6s infinite;
    -moz-animation: dotloader 2.5s 0.6s infinite;
    -ms-animation: dotloader 2.5s 0.6s infinite;
    -o-animation: dotloader 2.5s 0.6s infinite;
    animation: dotloader 2.5s 0.6s infinite;
  }

  @keyframes "dotloader" {
    0%,20% {
      width: 6px;
      height: 6px;
      -webkit-border-radius: 2px;
      -moz-border-radius: 2px;
      border-radius: 2px;
      left: 0%;
      background-color: rgba(19, 85, 130, 0);
    }

    30%,70% {
      width: 6px;
      height: 6px;
      -webkit-border-radius: 4px;
      -moz-border-radius: 4px;
      border-radius: 4px;
      left: 50%;
      background-color: rgba(19, 85, 130, 1);
    }

    80%,100% {
      width: 6px;
      height: 6px;
      -webkit-border-radius: 2px;
      -moz-border-radius: 2px;
      border-radius: 2px;
      left: 100%;
      background-color: rgba(19, 85, 130, 0);
    }
  }

  @-moz-keyframes dotloader {
    0%,20% {
      width: 6px;
      height: 6px;
      -moz-border-radius: 2px;
      border-radius: 2px;
      left: 0%;
      background-color: rgba(19, 85, 130, 0);
    }

    30%,70% {
      width: 6px;
      height: 6px;
      -moz-border-radius: 4px;
      border-radius: 4px;
      left: 50%;
      background-color: rgba(19, 85, 130, 1);
    }

    80%,100% {
      width: 6px;
      height: 6px;
      -moz-border-radius: 2px;
      border-radius: 2px;
      left: 100%;
      background-color: rgba(19, 85, 130, 0);
    }
  }

  @-webkit-keyframes "dotloader" {
    0%,20% {
      width: 6px;
      height: 6px;
      -webkit-border-radius: 2px;
      border-radius: 2px;
      left: 0%;
      background-color: rgba(19, 85, 130, 0);
    }

    30%,70% {
      width: 6px;
      height: 6px;
      -webkit-border-radius: 4px;
      border-radius: 4px;
      left: 50%;
      background-color: rgba(19, 85, 130, 1);
    }

    80%,100% {
      width: 6px;
      height: 6px;
      -webkit-border-radius: 2px;
      border-radius: 2px;
      left: 100%;
      background-color: rgba(19, 85, 130, 0);
    }
  }

  @-ms-keyframes "dotloader" {
    0%,20% {
      width: 6px;
      height: 6px;
      border-radius: 2px;
      left: 0%;
      background-color: rgba(19, 85, 130, 0);
    }

    30%,70% {
      width: 6px;
      height: 6px;
      border-radius: 4px;
      left: 50%;
      background-color: rgba(19, 85, 130, 1);
    }

    80%,100% {
      width: 6px;
      height: 6px;
      border-radius: 2px;
      left: 100%;
      background-color: rgba(19, 85, 130, 0);
    }
  }

  @-o-keyframes "dotloader" {
    0%,20% {
      width: 6px;
      height: 6px;
      border-radius: 2px;
      left: 0%;
      background-color: rgba(19, 85, 130, 0);
    }

    30%,70% {
      width: 6px;
      height: 6px;
      border-radius: 4px;
      left: 50%;
      background-color: rgba(19, 85, 130, 1);
    }

    80%,100% {
      width: 6px;
      height: 6px;
      border-radius: 2px;
      left: 100%;
      background-color: rgba(19, 85, 130, 0);
    }
  }
`;

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: Heebo;
    font-style: normal;
    font-weight: 100;
    font-display: swap;
    src: url(/fonts/heebo/Heebo-Thin.ttf) format("truetype");
  }

  @font-face {
    font-family: Heebo;
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url(/fonts/heebo/Heebo-ExtraLight.ttf) format("truetype");
  }

  @font-face {
    font-family: Heebo;
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url(/fonts/heebo/Heebo-Light.ttf) format("truetype");
  }

  @font-face {
    font-family: Heebo;
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(/fonts/heebo/Heebo-Regular.ttf) format("truetype");
  }

  @font-face {
    font-family: Heebo;
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url(/fonts/heebo/Heebo-Medium.ttf) format("truetype");
  }

  @font-face {
    font-family: Heebo;
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url(/fonts/heebo/Heebo-SemiBold.ttf) format("truetype");
  }

  @font-face {
    font-family: Heebo;
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(/fonts/heebo/Heebo-Bold.ttf) format("truetype");
  }

  @font-face {
    font-family: Heebo;
    font-style: normal;
    font-weight: 800;
    font-display: swap;
    src: url(/fonts/heebo/Heebo-ExtraBold.ttf) format("truetype");
  }

  @font-face {
    font-family: Heebo;
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url(/fonts/heebo/Heebo-Black.ttf) format("truetype");
  }

  ${typographyVariables}
  ${colorVariables}

  ${swiperStyles}
  ${customStyles}
  ${hoverStyles}
  ${modalStyles}
  ${dotAnimationStyles}
  ${captchaStyles}
  ${styledNormalize}
  html, body {
    position: relative;
    margin: 0;
    border: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  body {
    overflow: auto;
  }
  ${amStyles}
`;

export default GlobalStyles;
